import {executeQuery} from "@/main";
import upsertRegistration from 'raw-loader!./graphql/mutation/upsertRegistration.graphqls';
import insertAccreditation from 'raw-loader!./graphql/mutation/insertAccreditation.graphqls';
import publication from 'raw-loader!./graphql/query/publication.graphqls';
import accreditedMeetings from 'raw-loader!./graphql/query/accreditedMeetings.graphqls';
import meetingProgramme from 'raw-loader!./graphql/query/meetingProgramme.graphqls';
import pressKit from 'raw-loader!./graphql/query/pressKit.graphqls';
import embargoedAsset from 'raw-loader!./graphql/query/embargoedAsset.graphqls';
import {useUserStore} from "@/store/userStore";

export default class AccreditationService {
    upsertRegistration(registration){
        const userStore = useUserStore()
        const token = userStore.user && userStore.user.token != null ? userStore.user.token : null
        return executeQuery(token, upsertRegistration,{registration})
    }
    insertAccreditation(accreditation){
        const userStore = useUserStore()
        const token = userStore.user && userStore.user.token != null ? userStore.user.token : null
        return executeQuery(token, insertAccreditation,{accreditation})
    }
    publication(accountId,contactId){
        if(accountId != null && contactId != null){
            return executeQuery(null, publication,{accountId,contactId})
        }
        return new Promise(() => []);
    }
    accreditedMeetings(){
        const userStore = useUserStore()
        if(userStore.user && userStore.user.token != null){
            return executeQuery( userStore.user.token, accreditedMeetings,null).then(items => {
               return items.map(item => {
                   item.startDate = item.startDate != null ? item.startDate+"+00:00" : null
                   item.endDate = item.endDate != null ? item.endDate+"+00:00" : null
                   item.pressConferenceStart = item.pressConferenceStart != null ? item.pressConferenceStart+"+00:00" : null
                   return item
               })
            })
        }
        return new Promise(() => []);
    }
    meetingProgramme(meetingId){
        const userStore = useUserStore()
        if(userStore.user && userStore.user.token != null){
            return executeQuery( userStore.user.token, meetingProgramme, {meetingId})
        }
        return new Promise(() => {});
    }
    pressKit(meetingCode){
        const userStore = useUserStore()
        if(userStore.user && userStore.user.token != null){
            return executeQuery( userStore.user.token, pressKit, {meetingCode})
        }
        return new Promise(() => {});
    }
    embargoedAsset(publicId) {
        const userStore = useUserStore()
        if(userStore.user && userStore.user.token != null){
            return executeQuery(userStore.user.token, embargoedAsset, {publicId})
        }
        return new Promise(() => {});
    }
}
